<template>
  <validation-observer ref="form">
    <b-form-group>
      <validation-provider
        #default="{ errors }"
        name="motivo"
        rules="required|min:3|max:150"
      >
        <b-form-textarea
          v-model="inputText"
          :state="errors.length > 0 ? false:null"
          placeholder="Indique el motivo por el que le interesa participar en este proceso formativo"
        />
        <small class="text-danger">{{ errors[0] }}</small>
      </validation-provider>
    </b-form-group>
  </validation-observer>

</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { BFormGroup, BFormTextarea } from 'bootstrap-vue'
import { ref, watch } from '@vue/composition-api'
import { required } from '@validations'

export default {
  components: {
    BFormGroup,
    BFormTextarea,

    ValidationProvider,
    ValidationObserver,
  },
  setup(_, { emit }) {
    const form = ref(null)
    const inputText = ref('')

    watch(inputText, value => {
      emit('on-value-change', value)
    })

    return {
      form,
      inputText,

      required,
    }
  },
}
</script>
